/**
 * The hold meter (16.97, Don's direction): turn "1,412 / 1,568 m3" into a bar.
 *
 * A fraction is a division the player has to perform, and they have to perform
 * it at exactly the moment they are deciding how many units to buy. A bar is
 * that division already done.
 *
 * Pure and separate from the screen so the thresholds are testable: the state
 * worth noticing is "nearly out of room", which is precisely the state that is
 * hardest to reach on demand in a browser.
 */

export type HoldLevel = "ok" | "high" | "full";

/** Amber from three-quarters full, red from ninety-five percent. */
export const HOLD_HIGH_PCT = 75;
export const HOLD_FULL_PCT = 95;

export interface HoldFill {
  usedM3: number;
  /** 0-100, clamped. */
  pct: number;
  level: HoldLevel;
}

/**
 * Takes FREE space rather than used, because that is what the cargo helpers
 * return (`freeCargoM3` / `freeOreHoldM3`) and converting at the call site is
 * how an off-by-one inversion gets shipped.
 */
export function holdFill(freeM3: number, totalM3: number): HoldFill {
  if (!(totalM3 > 0)) return { usedM3: 0, pct: 0, level: "ok" };
  const usedM3 = Math.max(0, Math.min(totalM3, totalM3 - freeM3));
  const pct = (usedM3 / totalM3) * 100;
  return {
    usedM3,
    pct,
    level: pct >= HOLD_FULL_PCT ? "full" : pct >= HOLD_HIGH_PCT ? "high" : "ok"
  };
}
